<template>
  <div class="pc-footer">
    <div class="content flex-between">
      <div class="logo">
        <img src="../../assets/img/computer/logo.svg" alt />
        <p>
          {{ $t("footer.txt") }}
        </p>
      </div>
      <div class="link flex-center">
        <div class="link-url">
          <label>{{ $t("footer.linkTitle") }}</label>
          <a v-for="(item, index) in link.web" :key="index" :href="item.url" target="_blank">{{ item.title }}</a>
        </div>
        <!-- <div class="contact flex-left">
          <label>联系我们</label>
          <div class="icon-box">
          <i
            class="iconfont"
            :class="[item.icon, { icon: isHome }]"
            v-for="(item,index) in link.contact"
            :key="index"
          >
            <img :src="item.code" alt />
            <p>{{ item.name }}</p>
          </i>
          </div>
        </div>-->
      </div>
      <el-select v-model="lang" placeholder="Choose language" class="lang" size="small" @change="changeLang">
        <el-option label="简体中文" value="zh"></el-option>
        <el-option label="English" value="en"></el-option>
        <!-- <el-option label="日本語" value="ja"></el-option> -->
      </el-select>
    </div>
  </div>
</template>
<script>
import locale from "element-ui/lib/locale"; //locale兼容
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import jaLocale from "element-ui/lib/locale/lang/ja";
export default {
  data() {
    return {
      lang:
        localStorage.getItem("BLOCK_LANG") || process.env.VUE_APP_DEFAULT_LANG,
    };
  },
  computed: {
    isHome() {
      return this.$route.path === "/";
    },
    link() {
      return {
        web: [
          {
            title: this.$t("footer.bty"),
            url: "https://www.bityuan.com/",
          },
          {
            title: "X",
            url: "https://x.com/Bityuanofficial",
          },
          {
            title: "Telegram",
            url: "https://t.me/bityuanblockchain",
          },
          {
            title: "Discord",
            url: "https://discord.com/invite/P3gbgSbdg5",
          },
        ],
      };
    },
  },
  mounted() {
    document.title = this.$t("home.title");
  },
  methods: {
    changeLang(lang) {
      localStorage.setItem("BLOCK_LANG", lang);
      this.$i18n.locale = lang;
      switch (lang) {
        case "zh":
          locale.use(zhLocale);
          break;
        case "ja":
          locale.use(jaLocale);
          break;
        case "en":
          locale.use(enLocale);
          break;
        default:
          locale.use(zhLocale);
          break;
      }
      document.title = this.$t("home.title");
    },
  },
};
</script>

<style lang="scss">
.pc-footer {
  height: 154px;

  .content {
    height: 100%;
    width: 1200px;
    margin: 0 auto;

    .logo {
      height: 100%;
      width: 240px;
      padding-left: 10px;
      display: inline-block;

      img {
        margin-top: 38px;
        height: 35px;
      }

      p {
        margin-top: 12px;
        font-size: 14px;
        font-family: PingFangSC-Regular;
        font-weight: 400;
        color: $grey_deep;
        line-height: 20px;
      }
    }

    .link {
      // display: inline-block;
      width: 750px;
      height: 100%;
      padding: 30px 0 30px 30px;

      .link-url {
        height: 45px;
        line-height: 45px;

        label {
          color: $black;
          font-size: 14px;
          font-family: PingFangSC-Medium;
          font-weight: 600;
          margin-right: 32px;
        }

        a {
          display: inline-block;
          font-size: 14px;
          font-family: PingFangSC-Regular;
          font-weight: 400;
          color: $font_grey;
          margin-right: 70px;
        }

        a:hover {
          color: $blue;
        }
      }
    }

    .lang {
      width: 115px;

      input {
        // height: 30px;
        background: rgba(194, 199, 222, 1);
        border-radius: 15px;
        color: #fff;
        border: none;
      }

      .el-select__caret {
        color: #fff;
      }
    }
  }
}
</style>
